class CtxTableTreeviewController {
    constructor($attrs, $transclude, ivhTreeviewOptions, filterFilter, ivhTreeviewMgr) {
        this.$attrs = $attrs;
        this.$transclude = $transclude;
        this.ivhTreeviewOptions = ivhTreeviewOptions;
        this.filterFilter = filterFilter;
        this.ivhTreeviewMgr = ivhTreeviewMgr;
    }

    $onInit() {
        this.localOpts = angular.extend({}, this.ivhTreeviewOptions(), this.userOptions);

        angular.forEach([
            'childrenAttribute',
            'defaultSelectedState',
            'expandToDepth',
            'idAttribute',
            'indeterminateAttribute',
            'expandedAttribute',
            'labelAttribute',
            'nodeTpl',
            'selectedAttribute',
            'twistieCollapsedTpl',
            'twistieExpandedTpl',
            'twistieLeafTpl',
            'useCheckboxes',
            'validate',
            'visibleAttribute'
        ], attr => {
            if (angular.isDefined(this[attr])) {
                this.localOpts[attr] = this[attr];
            }
        });

        angular.forEach([
            'onCbChange',
            'onToggle'
        ], attr => {
            if (this.$attrs[this.normedAttr(attr)]) {
                this.localOpts[attr] = this[attr];
            }
        });

        this.transcludedScope;

        this.$transclude((clone, scope) => {
            let transcludedNodeTpl = '';
            angular.forEach(clone, c => {
                transcludedNodeTpl += (c.innerHTML || '').trim();
            });
            if (transcludedNodeTpl.length) {
                this.transcludedScope = scope;
                this.localOpts.nodeTpl = transcludedNodeTpl;
            }
        });

        this.userOpts = this.userOptions || {};

        this.hasLocalTwistieTpls = !!(
        this.userOpts.twistieCollapsedTpl ||
        this.userOpts.twistieExpandedTpl ||
        this.userOpts.twistieLeafTpl ||
        this.twistieCollapsedTpl ||
        this.twistieExpandedTpl ||
        this.twistieLeafTpl);
    }

    normedAttr(attrKey) {
        return 'ivhTreeview' +
            attrKey.charAt(0).toUpperCase() +
            attrKey.slice(1);
    }

    opts() {
        return this.localOpts;
    }

    children(node) {
        let children = node[this.localOpts.childrenAttribute];
        return angular.isArray(children) ? children : [];
    };

    getNodeLevel(node) {
        return node.level ? node.level : 0;
    }

    label(node) {
        return node[this.localOpts.labelAttribute];
    }

    hasFilter() {
        return angular.isDefined(this.filter);
    }

    getFilter() {
        return this.filter || '';
    };

    isVisible(node) {
        let filter = this.getFilter();

        if (!filter || this.filterFilter([node], filter).length) {
            return true;
        }

        if (typeof filter === 'object' || typeof filter === 'function') {
            let children = this.children(node);
            // If any child is visible then so is this node
            for (let ix = children.length; ix--;) {
                if (this.isVisible(children[ix])) {
                    return true;
                }
            }
        }

        return false;
    };

    useCheckboxes() {
        return this.localOpts.useCheckboxes;
    };

    select(node, isSelected) {
        this.ivhTreeviewMgr.select(this.root, node, this.localOpts, isSelected);
        this.onCbChange(node, isSelected);
    };

    isSelected(node) {
        return node[this.localOpts.selectedAttribute];
    };

    toggleSelected(node) {
        let isSelected = !node[this.localOpts.selectedAttribute];
        this.select(node, isSelected);
    };

    expand(node, isExpanded) {
        this.ivhTreeviewMgr.expand(this.root, node, this.localOpts, isExpanded);
    };

    isExpanded(node) {
        return node[this.localOpts.expandedAttribute];
    };

    toggleExpanded(node) {
        this.expand(node, !this.isExpanded(node));
    };

    isInitiallyExpanded(depth) {
        let expandTo = this.localOpts.expandToDepth === -1 ?
            Infinity : this.localOpts.expandToDepth;
        return depth < expandTo;
    };

    isLeaf(node) {
        return this.children(node).length === 0;
    };

    getNodeTpl() {
        return this.localOpts.nodeTpl;
    };

    getTranscludedNodeScope() {
        return this.transcludedScope;
    };

    getRoot() {
        return this.root;
    };

    onToggle(node) {
        if (this.localOpts.onToggle) {
            let locals = {
                ivhNode: node,
                ivhIsExpanded: this.isExpanded(node),
                ivhTree: this.root
            };
            this.localOpts.onToggle(locals);
        }
    };

    onCbChange(node, isSelected) {
        if (this.localOpts.onCbChange) {
            let locals = {
                ivhNode: node,
                ivhIsSelected: isSelected,
                ivhTree: this.root
            };
            this.localOpts.onCbChange(locals);
        }
    };
}

CtxTableTreeviewController.$inject = ['$attrs', '$transclude', 'ivhTreeviewOptions', 'filterFilter', 'ivhTreeviewMgr'];

class ctxTableTreeviewDirective {
    constructor(ivhTreeviewMgr) {
        this.ivhTreeviewMgr = ivhTreeviewMgr;
        this.restrict = 'A';
        this.transclude = true;
        this.controller = CtxTableTreeviewController;
        this.controllerAs = 'trvw';
        this.bindToController = {
            // The tree data store
            root: '=ctxTableTreeview',
            // Generic options object
            userOptions: '=ivhTreeviewOptions',
            // The filter
            filter: '=ivhTreeviewFilter'
        };
        this.template = require('./ctxTableTreeview.template.html');
    }

    link(scope, element, attrs) {
        let opts = scope.trvw.opts();

        if (opts.validate) {
            this.ivhTreeviewMgr.validate(scope.trvw.root, opts);
        }
    }

    static directiveFactory(ivhTreeviewMgr) {
        return new ctxTableTreeviewDirective(ivhTreeviewMgr);
    }
}

ctxTableTreeviewDirective.directiveFactory.$inject = ['ivhTreeviewMgr'];

module.exports = ctxTableTreeviewDirective.directiveFactory;



// WEBPACK FOOTER //
// ./src/shared/ctxTableTree/customDirectives/ctxTableTreeview.directive.js